<template>
    <grid-layout>
        <grid-layout-item v-if="!is_new">
            <base-alert
                v-if="identityDocument.reason"
                level="danger"
            >
                <template slot="heading">Unverifiable ID</template>
                <template slot="content">
                    <template v-if="identityDocument.reason">
                        {{ identityDocument.reason }}
                    </template>

                    <template v-else>
                        The identity document failed verification for an unknown reason.
                    </template>

                    Please try again.
                </template>
            </base-alert>

            <div class="flex items-center px-3 py-2 mb-6 border rounded bg-grey-lightest">
                <div class="flex-grow overflow-hidden truncate">
                    <template v-if="$_.has(identityDocument, 'front.name')">
                        <strong>Front: </strong> {{ identityDocument.front.name }}
                    </template>

                    <template v-if="$_.has(identityDocument, 'back.name')">
                        <br><strong>Back:</strong> {{ identityDocument.back.name }}
                    </template>
                </div>

                <button
                    type="button"
                    class="ml-3 border btn btn-sm"
                    :class="{ 'opacity-50': disabled }"
                    :disabled="disabled"
                    @click.prevent="is_new = true"
                >
                    Update
                </button>
            </div>
        </grid-layout-item>

        <template v-else>
            <grid-layout-item class="md:w-1/2">
                <form-item
                    :sid="sid"
                    :is-required="true"
                    :name="`${name}[front]`"
                    :validator-name="`${validatorName}.front`"
                >
                    <template slot="label">
                        {{ isDoubleSided ? 'Front' : 'File' }}
                    </template>

                    <input-upload
                        v-model="form.front"
                        :sid="sid"
                        :disabled="disabled"
                        :name="`${name}[front]`"
                        :validator-name="`${validatorName}.front`"
                        class="flex-grow"
                    />
                </form-item>
            </grid-layout-item>

            <grid-layout-item
                v-if="isDoubleSided"
                class="md:w-1/2"
            >
                <form-item
                    :sid="sid"
                    :is-required="true"
                    :name="`${name}[back]`"
                    :validator-name="`${validatorName}.back`"
                >
                    <template slot="label">Back</template>

                    <input-upload
                        v-model="form.back"
                        :sid="sid"
                        :disabled="disabled"
                        :name="`${name}[back]`"
                        :validator-name="`${validatorName}.back`"
                        class="flex-grow"
                    />
                </form-item>
            </grid-layout-item>
        </template>
    </grid-layout>
</template>

<script>
    import _ from 'lodash'

    export default {
        props: {
            value: {
                validator: value => typeof value === 'object' || value === null,
                required: true
            },
            sid: {
                type: String,
                required: true
            },
            identityDocument: {
                validator: value => typeof value === 'object' || value === null,
                default: null
            },
            name: {
                type: String,
                default: 'identity_document'
            },
            validatorName: {
                type: String,
                required: false,
                default () {
                    return this.name.replace(/\[/g, '.').replace(/\]/g, '')
                }
            },
            disabled: {
                type: Boolean,
                default: false
            },
            isDoubleSided: {
                type: Boolean,
                default: true
            }
        },
        data () {
            return {
                is_new: null,
                has_existing: false,
                form: {
                    front: null,
                    back: null
                }
            }
        },
        watch: {
            identityDocument () {
                this.has_existing = _.has(this.identityDocument, 'uuid')
                this.is_new = !this.has_existing
            },
            is_new () {
                this.$emit('input', this.is_new ? this.form : null)
            },
            form: {
                handler () {
                    this.$emit('input', this.form)
                },
                deep: true
            }
        },
        created () {
            this.has_existing = _.has(this.identityDocument, 'uuid')
            this.is_new = !this.has_existing
        }
    }
</script>
